var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4445 1.35254H1.55555C0.697812 1.35254 0 2.05039 0 2.90809C0 3.60945 0 16.3938 0 17.0923C0 17.95 0.697812 18.6478 1.55555 18.6478H18.4445C19.3022 18.6478 20 17.95 20 17.0923C20 16.3934 20 3.60926 20 2.90809C20 2.05039 19.3022 1.35254 18.4445 1.35254ZM18.6667 17.0923C18.6667 17.2148 18.567 17.3145 18.4445 17.3145H1.55555C1.43301 17.3145 1.33332 17.2148 1.33332 17.0923V6.00953H18.6666V17.0923H18.6667ZM18.6667 4.67621H1.33332V2.90809C1.33332 2.78555 1.43301 2.68586 1.55555 2.68586H18.4445C18.567 2.68586 18.6667 2.78555 18.6667 2.90809V4.67621Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80512 4.1825C3.08204 4.1825 3.30652 3.95801 3.30652 3.68109C3.30652 3.40417 3.08204 3.17969 2.80512 3.17969C2.5282 3.17969 2.30371 3.40417 2.30371 3.68109C2.30371 3.95801 2.5282 4.1825 2.80512 4.1825Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41254 4.1825C4.68946 4.1825 4.91395 3.95801 4.91395 3.68109C4.91395 3.40417 4.68946 3.17969 4.41254 3.17969C4.13562 3.17969 3.91113 3.40417 3.91113 3.68109C3.91113 3.95801 4.13562 4.1825 4.41254 4.1825Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01996 4.1825C6.29688 4.1825 6.52137 3.95801 6.52137 3.68109C6.52137 3.40417 6.29688 3.17969 6.01996 3.17969C5.74304 3.17969 5.51855 3.40417 5.51855 3.68109C5.51855 3.95801 5.74304 4.1825 6.01996 4.1825Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41809 16.3714L9.99941 14.3685L12.581 16.3714C13.0182 16.7107 13.6563 16.3981 13.6563 15.8446V7.47918C13.6563 7.11102 13.3578 6.8125 12.9896 6.8125H7.00945C6.64129 6.8125 6.34277 7.11098 6.34277 7.47918V15.8447C6.34277 16.4018 6.98379 16.7084 7.41809 16.3714ZM7.67609 8.14586H12.323V9.30551H7.67609V8.14586ZM7.67605 10.6389H12.323V14.4837L10.4081 12.998C10.1677 12.8114 9.83129 12.8114 9.59074 12.998L7.67609 14.4836L7.67605 10.6389Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedCampaign);
export default __webpack_public_path__ + "static/media/saved_campaign.413b63bf51bd5ba6491567855e1c25e3.svg";
export { ForwardRef as ReactComponent };